import script from "./ComAnalysisSimple.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComAnalysisSimple.vue?vue&type=script&setup=true&lang=ts"

import "./ComAnalysisSimple.vue?vue&type=style&index=0&id=54848f49&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54848f49"]])

export default __exports__